import type { ObjectId } from "@bbj-types/utils";
import type { CreateAction } from "@root/utils/enums/communication";
import { useCallback } from "react";
import { axios } from "./axios";

export interface ISendSMSBody {
  recipients: ObjectId[];
  content: string;
  createAction: CreateAction;
}

export const useSendSMS = () => {
  const [state, execute, cancel] = axios<void, ISendSMSBody, unknown>(
    {
      url: "/candidates/communication/sms",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: ISendSMSBody) => {
      return execute({ data });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
